import { render, staticRenderFns } from "./HelpBahasaMalaysia.vue?vue&type=template&id=6720d4fc"
import script from "./HelpBahasaMalaysia.vue?vue&type=script&lang=js"
export * from "./HelpBahasaMalaysia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports